import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { TenantService } from '../../services/tenant.service';
import { TenantIds } from '../../enums/tenants.enum';

/**
 * Structural directive to show content only for specific tenant
 * Usage: *appTenant="TenantIds.RADFORD"
 */
@Directive({
  selector: '[appTenant]',
  standalone: true
})
export class TenantDirective implements OnInit {
  @Input('appTenant') tenantId!: TenantIds;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private tenantService: TenantService
  ) {}

  ngOnInit(): void {
    this.tenantService.getCurrentTenantId().subscribe((currentTenantId: TenantIds) => {
      if (currentTenantId === this.tenantId) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
} 